import { ICarrier } from "../interfaces/configuration";
import { TEntity } from "../interfaces/userContext";
import { getFormDataFromCarriersList } from "../utils/credentials";

export interface IntegrationResult {
  success: boolean;
  error?: string;
}

// 1. integrar carriers con credenciales completas.
export const integrateCarriersWithCredentials = async (
  carriers: ICarrier[],
  entity: TEntity
): Promise<IntegrationResult> => {
  try {
    await getFormDataFromCarriersList(carriers, entity);
    return { success: true };
  } catch (error: any) {
    return {
      success: false,
      error: error.message || "Error al integrar carriers con credenciales",
    };
  }
};

// 2. al finalizar la cuenta sin configuración, integra el primer carrier por default.
export const integrateDefaultCarrier = async (
  defaultCarrier: ICarrier,
  entity: TEntity
): Promise<IntegrationResult> => {
  try {
    await getFormDataFromCarriersList([defaultCarrier], entity);
    return { success: true };
  } catch (error: any) {
    return {
      success: false,
      error: error.message || "Error al integrar carrier por defecto",
    };
  }
};
